import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-label", "error", "validationMessage", "required", "theme", "children"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import themePropType from '../utils/themePropType';
import VizExSmall from '../typography/VizExSmall';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultProps = {
  error: false,
  required: false
};
const FormControlWrapper = styled.div.withConfig({
  displayName: "VizExFormControl__FormControlWrapper",
  componentId: "lt8ygm-0"
})(["width:100%;flex-basis:100%;"]);
class VizExFormControl extends Component {
  constructor(...args) {
    super(...args);
    this.getChildProps = ({
      ariaLabel,
      newError,
      newRequired,
      validationMessage,
      fallbackId,
      ref
    }) => {
      const childProps = {
        'aria-label': ariaLabel,
        required: newRequired,
        'aria-invalid': newError,
        'aria-required': newRequired,
        ref
      };
      if (fallbackId) {
        childProps.id = fallbackId;
      }
      if (newError) {
        childProps.error = validationMessage;
      }
      return childProps;
    };
  }
  render() {
    const _this$props = this.props,
      {
        'aria-label': ariaLabel,
        error,
        validationMessage,
        required,
        theme,
        children
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const renderedInput = children(Object.assign({}, this.getChildProps({
      ariaLabel,
      newError: error,
      newRequired: required,
      validationMessage
    })));
    return /*#__PURE__*/_jsxs(FormControlWrapper, Object.assign({}, rest, {
      children: [renderedInput, validationMessage ? /*#__PURE__*/_jsx(VizExSmall, {
        use: error ? 'error' : 'default',
        theme: theme,
        children: validationMessage
      }) : null]
    }));
  }
}
VizExFormControl.displayName = 'VizExFormControl';
VizExFormControl.propTypes = {
  'aria-label': PropTypes.string,
  children: PropTypes.func.isRequired,
  error: PropTypes.bool,
  required: PropTypes.bool,
  theme: themePropType,
  validationMessage: PropTypes.node
};
VizExFormControl.defaultProps = defaultProps;
export default VizExFormControl;